import { AccountGateway } from "@mojility/coach-core";

export default {
  name: 'accountGateway',
  fn: AccountGateway
};